export const getAllStylists = (stylists) => stylists.filter((s) => s.has_column && s.status !== 'deleted');
